export enum ComparisonOperators {
  IsChecked = 'rulesAdmin.conditions.isChecked',
  Includes = 'rulesAdmin.conditions.includes',
  IsEqual = 'rulesAdmin.conditions.equal',
  GreaterThan = 'rulesAdmin.conditions.greaterThan',
  LowerThan = 'rulesAdmin.conditions.lowerThan',
  EqualOrLowerThan = 'rulesAdmin.conditions.lowerThanOrEqualTo',
  EqualOrGreaterThan = 'rulesAdmin.conditions.greaterThanEqualTo',
  IsCompleted = 'rulesAdmin.conditions.isCompleted',
}

export enum Actions {
  IsRequired = 'rulesAdmin.actions.isRequired',
  IsVisible = 'rulesAdmin.actions.isVisible',
}

export interface Condition {
  id: string;
  fieldId: string;
  comparisonOperator: ComparisonOperators;
  value?: string;
}

export interface Target {
  id: string;
  fieldId: string;
  action: Actions;
  value?: string;
}

export interface Rule {
  id: string;
  name: string;
  conditions: Condition[][];
  targets: Target[];
  sectionMultipleId?: string;
}
